import "./index.less";
import { toMasskedAddress } from "../../extensions";
import { Tooltip } from "antd";
import { handleLicensedText } from "../../utils/commonUtils";
import MythImage from "../MythImage";

type ICopyrightInfo = {
    licensedStatus: number,
    licensedTime: string,
    licensedWallet?: string,
    collectionLogo: string,
    collectionName: string,
    licensedMode: string,
    nftImage: string,
    licensedNFTokenId: string
}

interface IProps {
    copyrightInfo: ICopyrightInfo
}

export const CopyRightContent = ({ copyrightInfo }: IProps) => {
    return <div className="copyright-info-content flex-row" >
        <div className="copyright-item">
            <div className="info-label">Licensing Time</div>
            <div className="info-content">{handleLicensedText(copyrightInfo.licensedStatus, copyrightInfo.licensedTime)}</div>
        </div>
        <div className="copyright-item">
            <div className="info-label">Collection</div>
            <div className="info-content flex-row collection-info">
                <MythImage className="info-img" src={copyrightInfo.collectionLogo} alt="" />
                <p className="collection-name">{copyrightInfo.collectionName}</p>
            </div>
        </div>
        <div className="copyright-item">
            <div className="info-label">IP</div>
            <div className="info-content">
                <div className="flex-row collection-nft">
                    <MythImage className="info-img" src={copyrightInfo.nftImage} alt="" />
                    <div><p className="font-pingfang">#{copyrightInfo.licensedNFTokenId}</p><p className="collection-name">{copyrightInfo.collectionName}</p></div>
                </div>
            </div>
        </div>
        <div className="copyright-item">
            <div className="info-label">Licensing Address</div>
            <div className="info-content"><Tooltip title={copyrightInfo.licensedWallet}>{toMasskedAddress(handleLicensedText(copyrightInfo.licensedStatus, copyrightInfo.licensedWallet))}</Tooltip></div>
        </div>
        <div className="copyright-item">
            <div className="info-label">Licensing Method</div>
            <div className="info-content">{handleLicensedText(copyrightInfo.licensedStatus, copyrightInfo.licensedMode)}</div>
        </div>
    </div>
}
